import axios, { AxiosResponse } from 'axios'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { TApprovalPosts } from './types'
// Handle posts

export const postApprovalPostsThunk = createAsyncThunk(
  'posts/postApprovalPostsThunk',
  async (data: TApprovalPosts, { getState, rejectWithValue, ...thunkApi }) => {
    try {
      const responsepostDuplicatePost: AxiosResponse<any> = await axios.post(
        `/posts/approvals/batch`,
        data
      )
      return responsepostDuplicatePost.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)
